module.exports = __webpack_public_path__ + "static/media/ali.fbd496fb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ali.jpeg
// module id = 281
// module chunks = 0